import consumer from "./consumer"

// Move the subscription creation outside DOMContentLoaded
// and make it conditional on element existence with MutationObserver

let channelInitialized = false;

function initializeClientChannel() {
    if (channelInitialized) return;
    let client_pages = document.getElementById('app-body')

    if (client_pages) {
        channelInitialized = true
        const subscription = consumer.subscriptions.create("ClientChannel", {
            connected() {
                // Add connection data
            },

            disconnected() {
                // Handle disconnection if needed
            },

            received(data) {
                console.log('Received data from ClientChannel')
                if (data.member_id) {
                    this.onlineMembers(data)
                    console.log('Received data for member ' + data.member_id)
                } else {
                    this.addAlert(data)
                }
            },

            onlineMembers(data) {
                console.log('Updating online members')
                let modalIconAccess = document.getElementById('online-members')
                let listItems = document.getElementById('online-members-list')
                let listItem = document.getElementById('member_' + data.member_id)
                let onlineMembersCount = document.getElementById('online-members-count')

                if (data.online === true) {
                    listItems.insertAdjacentHTML('afterbegin', data.html)
                    onlineMembersCount.innerHTML = String(listItems.children.length)
                    modalIconAccess.classList.remove('hidden')
                } else {
                    listItem.remove()
                    onlineMembersCount.innerHTML = String(listItems.children.length)
                    if (listItems.children.length === 0) {
                        modalIconAccess.classList.add('hidden')
                    }
                }
            },

            addAlert(data) {
                const messages = document.getElementById('flash-messages')
                let flashType = 'alert-success'
                if (data.title.includes('Error')) {
                    flashType = 'alert-danger'
                }
                messages.insertAdjacentHTML('beforeend', `<div class='alert alert-dismissable ${flashType}' style="color: #ffffff"><button class='close' data-dismiss='alert'><span style='color: #666666'>x</span></button>${data.body}</div>`)
            }
        })

        // Store subscription reference if needed
        window.clientChannelSubscription = subscription
    }
}

// Run initialization when DOM is loaded
document.addEventListener('DOMContentLoaded', initializeClientChannel)

// Also check if DOM is already loaded (in case script loads late)
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initializeClientChannel()
}

// Optional: Watch for element appearance if it might be added dynamically
if (!document.getElementById('app-body')) {
    const observer = new MutationObserver((mutations, obs) => {
        if (document.getElementById('app-body')) {
            initializeClientChannel()
            obs.disconnect()
        }
    })

    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}
